(() => {
  const instances = new WeakMap();

  const initialize = (root) => {
    if (!root || instances.has(root)) return;

    const track = root.querySelector('[data-elorene-trustpilot-track]');
    if (!track || track.children.length < 2) return;

    let moving = false;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const finishMove = (event) => {
      if (!moving || event.target !== track || event.propertyName !== 'transform') return;

      track.style.transition = 'none';
      track.append(track.firstElementChild);
      track.style.transform = 'translate3d(0, 0, 0)';
      track.getBoundingClientRect();
      moving = false;
    };

    const moveOneCard = () => {
      if (moving || document.hidden || prefersReducedMotion.matches) return;

      const firstCard = track.firstElementChild;
      if (!firstCard) return;

      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const distance = firstCard.getBoundingClientRect().width + gap;
      if (!distance) return;

      moving = true;
      track.style.transition = 'transform 620ms cubic-bezier(0.22, 1, 0.36, 1)';
      track.style.transform = `translate3d(-${distance}px, 0, 0)`;
    };

    track.addEventListener('transitionend', finishMove);
    const timer = window.setInterval(moveOneCard, 5000);

    instances.set(root, () => {
      window.clearInterval(timer);
      track.removeEventListener('transitionend', finishMove);
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-elorene-trustpilot]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-elorene-trustpilot]').forEach((root) => {
      const destroy = instances.get(root);
      if (destroy) destroy();
      instances.delete(root);
    });
  });
})();
